import React from 'react';
import { TableRow, TableCell } from '@mui/material';
import DownloadExport from './DownloadExport';
import { IDataExport } from '../../types/my-types';

export interface DataExportsTableRowProps {
  exportRow: IDataExport;
}

const DataExportsTableRow: React.FC<DataExportsTableRowProps> = ({ exportRow }) => {
  const createdDate = new Date(exportRow?.created_at);
  return (
    <TableRow>
      <TableCell>{exportRow.id}</TableCell>
      <TableCell>
        <div>
          {Object.entries(exportRow.filters).map(([key, value]: [string, string]) => {
            return (
              <div key={key}>
                <span style={{ color: '#5f6d7e' }}>{key}:</span>{' '}
                <span>{typeof value === 'string' ? value.replaceAll(',', ', ') : value}</span>
              </div>
            );
          })}
        </div>
      </TableCell>
      <TableCell>
        {createdDate.toDateString()} {createdDate.toLocaleTimeString()}
      </TableCell>
      <TableCell align="center" data-cy="tbl-cell-data-exports-status">
        {exportRow.status === 'Success' ? (
          <DownloadExport exportRow={exportRow} />
        ) : (
          <span style={{ color: '#5f6d7e', fontSize: '12px' }}>{exportRow.status}</span>
        )}
      </TableCell>
    </TableRow>
  );
};

export default DataExportsTableRow;
